<script>
import baseMixin from '@/mixins/baseMixin'
import NavDrawerActionButton from '@components/layout/nav-drawer-action-button.vue'
import NavDrawerProfileActionsContainer from '@components/layout/nav-drawer-profile-actions-container.vue'
import BaseLogo from '../_base-logo.vue'
import TheCreateBookingBtn from './the-create-booking-btn.vue'
import TheNavLinks from './the-nav-links.vue'

export default {
  name: 'MobileNavDrawer',
  components: {
    BaseLogo,
    TheCreateBookingBtn,
    TheNavLinks,
    NavDrawerActionButton,
    NavDrawerProfileActionsContainer,
  },
  mixins: [baseMixin],
  data: () => {
    return {
      isBottomSheetOpen: false,
    }
  },
}
</script>

<template>
  <div
    v-if="isMobileViewPort"
    class="mobile-nav-icon d-inline-block align-start"
  >
    <!-- Mobile menu button -->
    <BaseButton
      class="mobile-navbar-toggler-icon"
      icon="mdi-menu"
      fab
      tertiary
      sm
      hover-color="transparent"
      :width="'20'"
      :height="'20'"
      @click="isBottomSheetOpen = !isBottomSheetOpen"
    />

    <!-- Bottom Sheet -->
    <v-bottom-sheet v-model="isBottomSheetOpen">
      <v-sheet class="v-sheet-options">
        <div class="pt-4">
          <div class="drag-handler"></div>
        </div>

        <div
          class="pb-1 px-4 d-flex align-center justify-center space-x-1 h-36 mb-4"
        >
          <div class="d-flex align-center">
            <BaseLogo :width="'120'" :height="'36'" />
          </div>
        </div>

        <TheCreateBookingBtn block />

        <!-- Navigation Items -->
        <TheNavLinks />

        <v-spacer></v-spacer>

        <!-- Setting & Help -->
        <NavDrawerActionButton />

        <v-divider width="90%" class="opacity-6 mt-2 mb-2 mx-auto"></v-divider>

        <!-- Profile & Logout -->
        <NavDrawerProfileActionsContainer />
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<style lang="scss" scoped>
@import '@styles';
.mobile-navbar-toggler-icon {
  height: 20px !important;
}

.drag-handler {
  width: 32px;
  height: 4px;
  margin: 0 auto 12px;
  background: $color-neutral-grey-200;
  border-radius: 100px;
}

.nav-active {
  color: $color-blue-500 !important;
  background-color: $color-info-250;
  border-radius: 8px;

  .v-icon {
    color: $color-blue-400 !important;
  }
}

.v-icon {
  color: $color-neutral-grey-400 !important;
}

.v-list-item__icon {
  margin: 14px 0;
  margin-right: 12px !important;
}

.v-list-item .v-list-item__title {
  font-weight: 500;
}
</style>
